import { displayEmployeesPage } from "./displays/display-employees-page";
import {
  disableEmployees,
  enableEmployees,
} from "../../infrastructure/repository/employees-repository";
import { findCompanyId } from "../../infrastructure/repository/company-repository";

export async function toggleEmployees({ employeeIds, activate, currentPage }) {
  const companyId = await findCompanyId();
  if (activate) {
    await enableEmployees(employeeIds, companyId);
  } else {
    await disableEmployees(employeeIds, companyId);
  }

  displayEmployeesPage({ currentPage });
}
